<template>
	<v-container>
		<div v-if="volunteers.length === 0" class="ml-4">
			<!--			Udział wolontariuszy nie jest przewidziany.-->
		</div>

		<div v-else style="page-break-inside: avoid;" class="mb-3">
			<h2 class="mb-2">Wolontariusze</h2>
			<div v-for="(v, index) in volunteers" :key="index" class="mt-2">
				<v-layout row>
					<h4 class="mr-2">{{1+index}}.</h4>
					{{getVolunteerInfo(v.volunteerCode)}}
				</v-layout>
				<div v-for="(vt, vtIndex) in v.volunteeringTerms" :key="vtIndex">
					<div class="ml-5 mt-2">
						<strong class="mr-2">Zadeklarowany okres wolontariatu:</strong>
						{{(!vt.projectStartDate || !vt.projectEndDate) ? 'brak' : vt.projectStartDate + ' - ' +
							vt.projectEndDate}}
					</div>
					<div class="ml-5">
						<strong class="mr-2">Rzeczywisty okres wolontariatu:</strong>
						{{(!vt.realStartDate || !vt.realEndDate) ? 'brak' : vt.realStartDate + ' - ' + vt.realEndDate}}
					</div>
				</div>
			</div>
		</div>
	</v-container>
</template>

<script>
	import {Volunteer} from "../../../api/generated/Volunteer";

	export default {
		name: "FinalReportVolunteersPrintView",

		data () {
			return {
				projectId: this.$route.params.projectId,
				loadedVolunteers: []
			};
		},

		methods: {

			findCachedVolunteerInfo (code) {
				return this.loadedVolunteers.find(x => x.code === code);
			},

			getVolunteerInfo (code) {
				if (!this.findCachedVolunteerInfo(code)) {
					this.loadedVolunteers.push({code: code, data: {}});
					Volunteer.getVolunteerOfferData(
						this,
						code,
						(response) => this.findCachedVolunteerInfo(code).data = response
					);
				}
				let cachedData = this.findCachedVolunteerInfo(code).data;
				if (!cachedData) {
					return "";
				}
				return cachedData.name + " " + cachedData.surname + " (" + cachedData.email + ")";
			},

			sync () {
				this.$emit('volunteers', this.volunteers);
			}
		},

		props: {
			volunteers: {}
		}
	};
</script>

<style scoped>

</style>